import { render } from "./addServicePopup.vue?vue&type=template&id=745afbc6&scoped=true"
import script from "./addServicePopup.vue?vue&type=script&lang=js"
export * from "./addServicePopup.vue?vue&type=script&lang=js"

import "./addServicePopup.vue?vue&type=style&index=0&id=745afbc6&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745afbc6"]])

export default __exports__